import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import { useParams } from "react-router-dom";
import GeneralidadesTareas from "./GeneralidadesTareas";
import ObjetivoDeEvaluacion from "./ObjetivoDeEvaluacion";
import ReunionAperturaTarea from "./ReunionAperturaTarea";
import InformacionInstitucionalTarea from "./InformacionInstitucionalTarea";
import AvancesEjesMedicionTareas from "./AvancesEjesMedicionTareas";
import FortalezasTareas from "./FortalezasAsistencialesTareas";
import FortalezasApoyoTareas from "./FortalezasApoyoTareas";
import TemasRelacionados from "./TemasRelacionados";
import EstadoTareas from "./EstadoTareas";
import ReunionCierre from "./ReuinionCierre";
import InstructivoNc from "../../Instructivos/InstrucionAvanceNc.docx";
import InstructivoSeg from "../../Instructivos/EsquemaSeguimiento.pdf";
import Tabla11 from "./Tabla11";
import Tabla11Obtener from "../Informes/Tabla11Obtener";
import AsignarTareasNC from "./NuevoCicloActividades/AsignaTareasNC";

function AsignarTareas(props) {
  let { id } = useParams();
  let { tipoSolicitud } = useParams();

  return (
    <div className="test">
      <div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Asignación De Actividades
                  </h6>
                </div>
                {tipoSolicitud == 5 ? (
                  <a
                    href={InstructivoNc}
                    download
                    style={{ textDecoration: "none" }}
                  >
                    <button className="btn btn-warning">Especificación</button>
                  </a>
                ) : (
                  <a
                    href={InstructivoSeg}
                    download
                    style={{ textDecoration: "none" }}
                  >
                    <button className="btn btn-warning">Especificación</button>
                  </a>
                )}
                {tipoSolicitud != 5 ? (
                  <div class="card-body">
                    <div class="table-responsive">
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <GeneralidadesTareas
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <ReunionAperturaTarea
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <InformacionInstitucionalTarea
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <AvancesEjesMedicionTareas
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <FortalezasTareas
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <FortalezasApoyoTareas
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <TemasRelacionados
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <EstadoTareas
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />

                        <ReunionCierre
                          idSolicitud={id}
                          tipoSolicitudId={tipoSolicitud}
                        />
                        <Tabla11 idSolicitud={id} />
                        <Tabla11Obtener idSolicitud={id} />
                      </table>
                    </div>
                  </div>
                ) : (
                  <AsignarTareasNC
                    idSolicitud={id}
                    tipoSolicitudId={tipoSolicitud}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AsignarTareas;
